// ── 계약 모달 본문 — 섹션을 설정한 차례대로 그린다 ──────────────────────────
// ContractModal.jsx 가 291줄이라 섹션 렌더를 분리했다 (2026-09-22).
// 미리보기(ContractFieldPreview)도 같은 부품을 쓰므로, 여기 한 곳만 고치면 둘 다 따라온다.
import React from 'react';
import { CustomerSection, DeliverySection, PersonnelSection } from './ModalInfoSections';
import { ProductsSection } from './ModalProductsSection';
import { PromoSection } from './ModalPromoSection';
import { ExistingPromoPanel } from './ExistingPromoPanel';
import { orderedSectionIds, isSectionVisible } from './contractFieldMeta';
import { sectionCard, sectionTitleBar, sectionDot } from './modalStyles';

/**
 * 설정이 없으면(cfg=null) 지금까지의 규칙 그대로 — 배송 정보만 수정할 때 보인다.
 * (설정을 읽지 못한 짧은 순간에도 화면이 튀지 않게 하는 안전망)
 */
function fallbackVisible(id, isNew) {
  return id === 'delivery' ? !isNew : true;
}

// 홍보물 보기만(회사별·통합 계약 화면) — 홍보물 칸 자리에 안내 한 줄. 주문 넣기는 5단계(홍보물 통합)에서 연다.
function PromoReadOnlyNote() {
  return (
    <div style={sectionCard}>
      <div style={sectionTitleBar('#7c3aed')}>
        <span style={sectionDot('#7c3aed')} />
        홍보물
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6 }}>
        이 화면에서는 홍보물 주문을 넣을 수 없습니다. 홍보물 관리에서 넣어 주세요.
      </div>
    </div>
  );
}

export function ContractModalSections({
  cfg, isNew, isReorder, isMobile,
  form, errors, setField, setForm, setDeliveryForm,
  inp, users, salesPersons, ticketTypes,
  toggleProduct, setCount, setValidity,
  formDesignCourier, promotionalItemsList,
  autoFocusNew, setAutoFocusNew,
  existingPromoOrderId = null, showInlinePromoPanel = false,
  promoWritable = true, // false = 회사별·통합 계약 화면(4-5, 결정 2-a) — 주문 넣기 칸 대신 안내 한 줄, 등록된 홍보물은 그대로 보인다
}) {
  const visible = (id) => (cfg ? isSectionVisible(cfg, id, { isNew }) : fallbackVisible(id, isNew));
  const common = { form, errors, setField, inp, isMobile, cfg, isNew };

  const render = {
    customer: () => <CustomerSection {...common} />,
    delivery: () => (
      <DeliverySection form={form} setForm={setDeliveryForm} formDesignCourier={formDesignCourier} cfg={cfg} isNew={isNew} />
    ),
    personnel: () => <PersonnelSection {...common} users={users} salesPersons={salesPersons} />,
    contract: () => (
      <ProductsSection
        {...common}
        ticketTypes={ticketTypes}
        toggleProduct={toggleProduct} setCount={setCount} setValidity={setValidity}
        isReorder={isReorder}
      />
    ),
    promo: () => (!promoWritable ? <PromoReadOnlyNote /> : (
      <PromoSection
        form={form} setForm={setForm} setField={setField}
        autoFocusNew={autoFocusNew} setAutoFocusNew={setAutoFocusNew}
        promotionalItemsList={promotionalItemsList}
      />
    )),
  };

  const ids = orderedSectionIds(cfg).filter(visible);

  return (
    <>
      {ids.map((id) => (
        <React.Fragment key={id}>
          {render[id]()}
          {/* 기존 홍보물 패널(모달 좁을 때 인라인) — 홍보물 칸 바로 앞에 붙는다 */}
          {id === 'promo' && showInlinePromoPanel && (
            <ExistingPromoPanel promotionalOrderId={existingPromoOrderId} visible variant="inline" />
          )}
        </React.Fragment>
      ))}
      {ids.length === 0 && (
        <div style={{ padding: '26px 14px', textAlign: 'center', fontSize: 12, color: 'var(--text-muted)' }}>
          보이기로 한 칸이 하나도 없습니다.
        </div>
      )}
    </>
  );
}
